export const img_fallback = "/img/error-icon/fallback-img.png";
